import { CardMedia as MuiCardMedia } from '@mui/material';
import { styled } from '@mui/system';

const CardMedia = styled(MuiCardMedia)({
  height: 95,
  width: '100%',
});

export default CardMedia;
